module.exports = __webpack_public_path__ + "img/ElsaidInMath.d3678fc3.png";